import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HOME_FAQS } from "@/content/homeFaqContent";

export function HomeFaq() {
  return (
    <section
      id="frequently-asked-questions"
      aria-labelledby="faq-heading"
      className="relative overflow-hidden bg-[#fffaf0] px-4 py-16 md:py-24"
    >
      <div aria-hidden="true" className="absolute -right-24 top-10 h-64 w-64 rounded-full bg-primary/10 blur-3xl" />
      <div className="container relative mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <div className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.24em] text-amber-800">
            <Sparkles className="h-4 w-4" aria-hidden="true" />
            Buyer guidance
          </div>
          <h2 id="faq-heading" className="max-w-md text-3xl font-bold tracking-tight text-foreground md:text-5xl">
            Questions, answered with clarity
          </h2>
          <p className="mt-5 max-w-md leading-7 text-muted-foreground">
            Helpful details about choosing, caring for and ordering spiritual products from Uma's Aura.
          </p>
        </div>

        <div className="rounded-2xl border border-amber-200/80 bg-white px-5 shadow-[0_24px_70px_-45px_rgba(120,72,0,0.45)] md:px-8">
          <Accordion type="single" collapsible className="w-full">
            {HOME_FAQS.map((faq, index) => (
              <AccordionItem
                key={faq.question}
                value={`faq-${index + 1}`}
                className="border-amber-100 last:border-b-0"
              >
                <AccordionTrigger className="min-h-16 gap-5 py-5 text-left text-base font-semibold leading-6 decoration-amber-700 underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-600 focus-visible:ring-offset-4 md:text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="pr-7 text-[15px] leading-7 text-muted-foreground md:text-base">
                  <p>
                    {faq.answerParts.map((part, partIndex) =>
                      typeof part === "string" ? (
                        part
                      ) : (
                        <Link
                          key={`${part.href}-${partIndex}`}
                          to={part.href}
                          className="rounded-sm font-semibold text-amber-800 underline decoration-amber-400 underline-offset-4 hover:text-amber-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-600 focus-visible:ring-offset-2"
                        >
                          {part.label}
                        </Link>
                      ),
                    )}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
